import React from 'react';
import './styles/App.css';
import './styles/captcha.css';
import LoadingIndicator from "./resources/js/LoadingIcon";
import {trackPromise} from "react-promise-tracker";
import CvnTable from "./cvn/CvnTable";
import {api} from "./api/v1/api";
import Header from "./header";
import 'react-app-polyfill/stable';
import Sps2InfoCaptcha from "./captcha/Sps2InfoCaptcha";
import {TextField} from "@material-ui/core"
import Button from "@material-ui/core/Button"
import Presenter from "./presenter/Presenter";
import NotAuthenticated from "./authentication/NotAuthenticated";
import buildTokenFromSources from "./utils/buildTokensFromSources";
import {deleteCookie, SPS_INFO_ACCESS_TOKEN} from "./utils/cookieUtils";
import {VSP_LOGIN_URL} from "./utils/constants";

/**
 * Main Entry Point for the SPS2 Info Web Application
 *
 */
export default class App extends React.Component{

    serverApi;

    /**
     * Constructor for Class App initializes a new api object used to make calls to the SPS Info Backend
     *
     * @param props props
     */
    constructor(props) {
        super(props);
        this.serverApi = new api();
        this.cfmHandler = this.cfmHandler.bind(this)
        this.cvnHandler = this.cvnHandler.bind(this)
        this.vinDecodeHandler = this.vinDecodeHandler.bind(this)
        this.programmingSequenceHandler = this.programmingSequenceHandler.bind(this)
        this.presenterHandler = this.presenterHandler.bind(this)
        this.calPresenterHandler = this.calPresenterHandler.bind(this)
        this.errorHandler = this.errorHandler.bind(this)
        this.captchaAttemptHandler = this.captchaAttemptHandler.bind(this)
        this.captchaHandler = this.captchaHandler.bind(this)
        this.attemptsLeftHandler = this.attemptsLeftHandler.bind(this)
        this.moduleSelectorHandler = this.moduleSelectorHandler.bind(this)
        this.getVinDecode = this.getVinDecode.bind(this)
        this.getCvn = this.getCvn.bind(this)
    }


    state = {
        isAuthenticated: null,
        cvnPartNumber: null,
        vinID: null,
        controllers: [],
        controllerCode: [],
        functions:[],
        methods: [],
        isControllerTable: false,
        refTree: [],
        isError: false,
        errorMessage: null,
        vinDecode: null,
        locale: null,
        displayCvnList: false,
        cvnList: [],
        adapterType: null,
        programmingSequence: null,
        renderCalPresenter: false,
        renderControllerPresenter: false,
        staticText: {GETCVN: "GET CVN", GETCALID: "GET CAL ID"},
        captchaCounter: -1,
        captchaAttempts: 0,
        captchaAnswered: false,
        renderAttemptsLeft: false,
        isValidVin: true,
        isInvalidWhitespaceCvn: true,
        isInvalidCvn: false,
        renderModuleSelector: false,
        captchaFunction: null,
        refreshInterval: null
    }

    /**
     * Renders the contents of the SPS2 Info web application, holds the containers that take up the full page
     *
     * @returns {*}
     */
    render() {
        if(!this.state.isAuthenticated){
            return(<NotAuthenticated/>)
        }
        else{
            return (
                <div className={"FullPage"} style={this.state.captchaCounter === 0 ?(
                    {backgroundColor: 'rgba(58, 42, 45, 0.5)', top: 0, bottom: 0, left:0, right:0, position: 'fixed'})
                    :({})}>
                    <div className={"Sps2CaptchaContainer"}>
                        {this.state.captchaCounter === 0 ?
                            (
                                <Sps2InfoCaptcha attemptHandler ={this.captchaAttemptHandler}
                                                 validationHandler = {this.captchaHandler}
                                                 presenterHandler = {this.presenterHandler}
                                                 callBackFunction = {this.state.captchaFunction}
                                />)
                            :
                            (<React.Fragment/>)
                        }
                    </div>
                    <div className={"Header"}>
                        <Header />
                        <div className={"loadingIndicator"} style={{filter: 'blur(0px)'}}>
                            <LoadingIndicator/>
                        </div>
                    </div>
                    <div className={"Content"}>
                        <div className={"InputContainer"}>
                            <TextField className={"calDataInput"} style={{ width: 200 }} label="VIN" onChange={e => this.setState({vinID: e.target.value.trim()})}/>
                            <Button className={"spsbuttonCal"} variant={"contained"} size={"small"} color={"primary"} onClick={
                                async e => this.state.captchaAnswered ? (this.getVinDecode(e)) : (this.setCaptchaHandler(this.getVinDecode))
                            }>
                                {this.state.staticText["GETCALID"]}
                            </Button>
                            <TextField className={"cvnInput"} style={{width:200}} label={"Part Number"} onChange={async e => await this.setState({cvnPartNumber: e.target.value.trim()})}/>
                            <Button className={"spsbuttonCvn"} variant={"contained"} size={"small"} color={"primary"} onClick={
                                async e => this.state.captchaAnswered ? (this.getCvn(e)):(this.setCaptchaHandler(this.getCvn))
                            }>
                                {this.state.staticText["GETCVN"]}
                            </Button>
                            {!this.state.isValidVin ? (
                                <div className={"invalid-vin"}>Invalid Vin: Make sure vin is 17 characters and Alpha Numeric </div>
                            ):(<React.Fragment/>)}
                            {this.state.isInvalidCvn ? (
                                //TO DO: Have this come in translated
                                <div className={"invalid-cvn"}>Invalid or unknown part number</div>
                            ):(<React.Fragment/>)}
                        </div>
                        {this.state.isError ? (<div className={"spsErrorMessage"}>{this.state.errorMessage}</div>):(<React.Fragment/>)}
                        <div className={"cvnTable"}>
                            {this.state.displayCvnList ? (
                                <CvnTable cvnList={this.state.cvnList}/>)
                                :(
                                    <React.Fragment/>)
                            }

                        </div>
                        <div className={"ControllerPresenter"}>
                            {this.state.renderControllerPresenter && this.state.captchaAnswered? (
                                <Presenter serverApi={this.serverApi} controllers={this.state.controllers}
                                                    functions={this.state.functions} methods={this.state.methods}
                                                    controllerReferenceTree={this.state.refTree}
                                                    objectData={this.state.vinDecode}
                                                    dataReset={this.state.vinDecode}
                                                    adapterType={this.state.adapterType}
                                                    programmingSequenceHandler={this.programmingSequenceHandler}
                                                    calPresenterHandler={this.calPresenterHandler}
                                                    errorHandler={this.errorHandler}/>
                            ) : (<React.Fragment/>)}

                        </div>
                    </div>
                    <div className={"Footer"}>
                    </div>
                </div>
            )
        }
    }

    componentDidMount() {

        const {accessToken} = buildTokenFromSources();

        // check parameters for access token
        if (accessToken !== '') {
            this.setSessionStorage(accessToken);
            // Remove all the cookies so the next login is a clean slate
            deleteCookie(SPS_INFO_ACCESS_TOKEN)
            this.setState({ isAuthenticated: true })
        } else {
            this.setState({ isAuthenticated: false })
            window.location.href = VSP_LOGIN_URL; // VSP Login Page
        }

        window.history.replaceState({}, document.title, "/spsinfo-ui");
    }

    setSessionStorage(accessToken) {
        sessionStorage.setItem(SPS_INFO_ACCESS_TOKEN, accessToken)
    }

    componentWillUnmount() {
        clearInterval(this.state.refreshInterval);
    }

    async endUserSession(){
        await this.serverApi.endUserSession().then()
    }

    async attemptsLeftHandler(){
        await this.setState({
            renderAttemptsLeft: false,
        })
    }

    async validatePartString(){
        let regexStartsWithSpace = /^[\s\t]+/
        if(this.state.cvnPartNumber !== null){
            return !regexStartsWithSpace.test(this.state.cvnPartNumber)
        }
    }
    async getCvn(e){
        //let isValidPartString = await this.validatePartString()
        await this.setState({
            renderControllerPresenter: false,
            isInvalidWhitespaceCvn: true,
            isInvalidCvn:false,
        })

            this.state.captchaCounter = await (this.state.captchaCounter + 1) % 7
            if (this.state.captchaCounter !== 0)
                await trackPromise(this.serverApi.grabCvn(e, this.cvnHandler, this.state.cvnPartNumber, this.errorHandler))
            else {
                await this.setState({
                    captchaAnswered: false,
                    renderControllerPresenter: false,
                    renderCalPresenter: false,
                    displayCvnList: false,
                    captchaFunction: this.getCvn,
                    isInvalidWhitespaceCvn: true,
                    isInvalidCvn: false
                })
            }
        }


    async validateVin(){
        let regex = /^[a-z0-9]+$/i
        if(this.state.vinID != null) {
            if (regex.test(this.state.vinID)) {
                if (this.state.vinID.length === 17) {
                    return true;
                }
            }
        }
        return false;
    }

    async moduleSelectorHandler(){
        await this.setState({
            renderModuleSelector: true
        })
    }

    async getVinDecode(e){
        let isValidVin = await this.validateVin()
        if(isValidVin){
            await this.setState({
                renderControllerPresenter: false,
                isValidVin: true,
                isInvalidWhitespaceCvn: true,
                isInvalidCvn: false,
            })
            this.state.captchaCounter = await (this.state.captchaCounter + 1) % 7
            if (this.state.captchaCounter !== 0)
                await trackPromise(this.serverApi.grabVinDecode(e, this.state.vinID, this.cfmHandler, this.vinDecodeHandler, this.presenterHandler,
                    this.errorHandler))
            else {
                await this.setState({
                    captchaAnswered: false,
                    renderControllerPresenter: false,
                    renderCalPresenter: false,
                    displayCvnList: false,
                    captchaFunction: this.getVinDecode,

                })
            }
        }else{
            await this.setState({
                isValidVin: false,
                renderControllerPresenter: false,
                renderCalPresenter: false,
                displayCvnList: false,
                isInvalidCvn: false,
            })
        }
    }
    async setCaptchaHandler( handler ){
        await this.setState({
            renderControllerPresenter: false,
            captchaCounter: 0,
            captchaFunction: handler,
        })
    }

    async captchaAttemptHandler(attempts){
        if(attempts === 6){
            await this.setState({
                captchaCounter: -1,
                captchaAttempts: 0,
                captchaAnswered: false,
            })
        }
    }

    async captchaHandler(e, answered, captchaFunction){
        this.state.captchaAnswered = answered
        await trackPromise(captchaFunction(e))
        //await trackPromise(this.state.captchaFunction(e))
        await this.setState({
            captchaCounter: this.state.captchaCounter+1
        })
    }

    /**
     * Handler used to turn off the Calibration Presenter and Controller Presenter
     * @returns {Promise<void>}
     */
    async presenterHandler(){
        await this.setState({
            renderControllerPresenter: false,
            renderCalPresenter: false,
            displayCvnList: false,
        })
    }

    /**
     * Handler for setting the Controllers, Functions, and Methods to be used for user selection
     *
     * @param c the list of controllers
     * @param f the list of functions
     * @param m the list of methods
     * @returns {Promise<void>}
     */
    async cfmHandler(c, f, m){
        await this.setState({
            controllers: c,
            functions: f,
            methods: m
        })
    }

    /**
     * The handler for when the user clicks the Get Cvn Button, turns off the other presenters
     *
     * @param cvn The cvn list to be displayed
     * @returns {Promise<void>}
     */
    async cvnHandler(cvn){
        let invalidCvn = /^(e)/.test(cvn[0])

        await this.setState({
            cvnList: cvn,
            displayCvnList: !invalidCvn,
            renderControllerPresenter: false,
            renderCalPresenter: false,
            isError: false,
            isInvalidCvn: invalidCvn,
        })
    }

    /**
     * Handler used when the user is trying to obtain the VinDecode object from the SPS2 Info backend
     *
     * @param data The VinDecodeObject
     * @param adapter   The adapter type associated with the vin
     * @returns {Promise<void>}
     */
    async vinDecodeHandler(data, adapter){
        this.setState({
            vinDecode: data,
            refTree:  data.controllerReferenceTree.referenceTree,
            isControllerTable: true,
            adapterType: adapter,
            renderControllerPresenter: true,
            renderAttemptsLeft: true,
            isError: false,
        })
    }

    /**
     * Handler used when trying to retrieve the calibration data from the SPS2 Info Backend
     *
     * @param programmingSeq The CalibrationData Object returned from the SPS2 Info Backend
     * @returns {Promise<void>}
     */
    async programmingSequenceHandler(programmingSeq){
        await this.setState({
            programmingSequence: programmingSeq,
            renderCalPresenter: true,
        })
    }

    /**
     * Handler used to turn off the Calibration Presenter
     *
     * @returns {Promise<void>}
     */
    async calPresenterHandler(){
        await this.setState({
            renderCalPresenter: false
        })
    }

    /**
     * Handler used for when an error is returned from the SPS2 Info Backend
     *
     * @returns {Promise<void>}
     */
    async errorHandler(responseMessage, responseStatus){
        if(responseStatus === 408 || responseStatus === 403){
            window.location.reload(true)
        }
        await this.setState({
            isError: true,
            renderCalPresenter: false,
            renderControllerPresenter: false,
            displayCvnList: false,
            errorMessage: responseMessage,
        })
    }

    onChangeVin(e){
        let value = e.target.value
        let regex = /^[a-z0-9]+$/i
        if(regex.test(value)){
            this.setState({vinID: value})
        }
    }
}